import { useEffect } from 'react';

export function useOnLeaveURL(isDirty: boolean, callback?: () => void) {
    useEffect(() => {
        if (isDirty) {
            const handleBeforeUnload = (event: { preventDefault: () => void; returnValue: string }) => {
                callback?.();

                event.preventDefault();
                event.returnValue = '';
            };

            window.addEventListener('beforeunload', handleBeforeUnload);

            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [callback, isDirty]);
}
